
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformVertical as ObiTransformVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transform-vertical.js';
 
 
 

 
 export const ObiTransformVertical = createComponent({
   react: React,
   tagName: 'obi-transform-vertical',
   elementClass: ObiTransformVerticalElement,
   events: {
     
   }
  });
 
 